import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import axios from 'axios';
import api from '../utils/api';
import { API_URL } from '../components/config';
import { getViewAsMode, isPublicViewMode } from '../utils/viewMode';
import './HarvestingContactPage.css';

const HarvestingContactPage = () => {
  const location = useLocation();
  const [contactInfo, setContactInfo] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const viewAsMode = getViewAsMode(location.search);
  const publicPreview = isPublicViewMode(location.search);
  const previewQuery = viewAsMode ? `?viewAs=${viewAsMode}` : '';

  useEffect(() => {
    fetchContactInfo();
  }, []);

  const fetchContactInfo = async () => {
    try {
      setError('');
      const response = publicPreview
        ? await axios.get(`${API_URL}/api/harvesting-contact`)
        : await api.get('/api/harvesting-contact');
      setContactInfo(response.data.content || getDefaultContactInfo());
      setLoading(false);
    } catch (err) {
      console.error('Error fetching contact info:', err);
      setError('Could not load saved contact info. Showing default contact details.');
      // Use default contact info if API fails
      setContactInfo(getDefaultContactInfo());
      setLoading(false);
    }
  };

  const getDefaultContactInfo = () => {
    return `
      <div class="contact-section">
        <h2>Contact Information</h2>
        <p>For general harvesting inquires please contact:</p>
        <p><strong>📞 807-623-4635 x 400</strong></p>
        <p><strong>📧 <a href="mailto:harvesting@rsmin.ca">harvesting@rsmin.ca</a></strong></p>
        
        <br/>
        
        <p>For reporting harvesting activities or concerns please use the CIP harvesting workspace from the main harvesting portal or contact:</p>
        <p><strong>📞 807-623-4635 x 401</strong></p>
        <p><strong>📧 <a href="mailto:harvesting@rsmin.ca">harvesting@rsmin.ca</a></strong></p>
        
        <br/>
        
        <h3>Office Location</h3>
        <p>
          408 Victoria Avenue East<br/>
          Thunder Bay, Ontario<br/>
          P7C 1A5
        </p>
      </div>
    `;
  };

  return (
    <div className="harvesting-contact-page">
      <div className="page-header">
        <Link to={`/harvesting${previewQuery}`} className="back-link">← Back to Harvesting Portal</Link>
        <h1>Contact Us</h1>
        <p className="subtitle">Get in touch with our harvesting team</p>
      </div>

      <div className="contact-content">
        {loading ? (
          <div className="loading-container">
            <div className="spinner"></div>
            <p>Loading contact information...</p>
          </div>
        ) : error ? (
          <div className="error-container">
            <p className="error-message">{error}</p>
          </div>
        ) : contactInfo ? (
          <div 
            className="contact-info-display" 
            dangerouslySetInnerHTML={{ __html: contactInfo }}
          />
        ) : (
          <div className="no-info">
            <p>Contact information is not currently available.</p>
            <p>Please check back later or visit our main office.</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default HarvestingContactPage;
